var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.324,
    height: 30,
    viewBox: "0 0 24.324 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_37",
    "data-name": "Union 37",
    d: "M-4459-8267.066a12.08,12.08,0,0,1,8.173-11.4l-3.308-5.251,2.062-1.28,3.752,5.955a12.377,12.377,0,0,1,1.482-.088,12.544,12.544,0,0,1,1.889.144l3.787-6.011,2.062,1.28-3.391,5.381a12.075,12.075,0,0,1,7.815,11.273A12.115,12.115,0,0,1-4446.838-8255,12.115,12.115,0,0,1-4459-8267.066Zm5.282-6.826a9.553,9.553,0,0,0-2.849,6.826,9.555,9.555,0,0,0,2.849,6.825,9.707,9.707,0,0,0,6.88,2.826,9.7,9.7,0,0,0,6.88-2.826,9.553,9.553,0,0,0,2.85-6.825,9.552,9.552,0,0,0-2.85-6.826,9.707,9.707,0,0,0-6.88-2.827A9.712,9.712,0,0,0-4453.718-8273.893Z",
    transform: "translate(4459 8285.001)",
    fill: "#707070"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingIcon);
export default __webpack_public_path__ + "static/media/setting__icon.6ceab4baf834413225921e61184dad1a.svg";
export { ForwardRef as ReactComponent };